/** @format */

import logo from "./logo.svg";
import "./App.css";
import DamChart from "./components/damchart";
import DamTable from "./components/damtable";
import Header from "./components/Header";
import SummaryCallOption from "./components/SummaryCallOption";
import ClientManager from "./components/ClientManager";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import { useState } from "react";

function App() {
  const [submittedEmail, setSubmittedEmail] = useState(
    localStorage.getItem("loggedInEmail") || ""
  );

  const handleLogout = () => {
    localStorage.removeItem("loggedInEmail");
    setSubmittedEmail("");
  };

  return (
    <BrowserRouter>
      <div className='container'>
        <Header submittedEmail={submittedEmail} onLogout={handleLogout} />
        <Routes>
          {/* Αρχική σελίδα */}
          <Route
            path='/'
            element={
              <HomePage
                submittedEmail={submittedEmail}
                setSubmittedEmail={setSubmittedEmail}
              />
            }
          />

          <Route path='/clients' element={<ClientManager />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
